import script from "./TaxLiablityOtherIncomeFZP.vue?vue&type=script&setup=true&lang=js"
export * from "./TaxLiablityOtherIncomeFZP.vue?vue&type=script&setup=true&lang=js"

import "./TaxLiablityOtherIncomeFZP.vue?vue&type=style&index=0&id=5ba7fdd7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ba7fdd7"]])

export default __exports__